<template>
    <div>
        <public-title>房型动态</public-title>
        <div class="bg-white box-shadow">
            <header class="pl-3">酒店信息</header>
            <div class="pt-4 pl-3 pr-3 pb-4" v-if="multipleSelection">
                <div class="text-left">待推送酒店：<span class="text-warning">{{multipleSelection.length}}&nbsp;</span>家</div>
                <el-row class="mt-2">
                    <el-col :span="8" v-for="(item, index) in multipleSelection" :key="index" class="conspan">
                        <el-input size="small" v-model.number="item.index" />{{item.store_title}}
                    </el-col>
                </el-row>
                <el-button class="mt-5" type="primary" @click="toPush">开始匹配</el-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RoomBatchDetail',
    data () {
        return {
            multipleSelection: [],
        }
    },
    created () {
        this.multipleSelection = JSON.parse(sessionStorage.getItem('batchmul'))
    },
    methods: {
        // 排序
        compare(property){
            return function(a,b){
                var value1 = a[property];
                var value2 = b[property];
                return value1 - value2;
            }
        },
        // 推量推送开始匹配
        toPush () {
            let obj = this.multipleSelection.map(v => v.id)
            sessionStorage.setItem('settime', obj)
            let sortArr = this.multipleSelection.sort(this.compare('index'))
            let sortid = this.multipleSelection.map(v => v.id)
            sessionStorage.setItem('sort', sortid)
            this.$router.push({name:'MatchList', query:{time: 'session', page: 1}})
        }
    }
}
</script>

<style lang="scss" scoped>
header{
    height: 40px;
    line-height: 40px;
    text-align: left;
    background-color: #f8f8f8
}
.box-shadow{
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04) 
}
.el-row{
    border-top: 1px solid #eee;
    border-left: 1px solid #eee
}
.conspan{
    height: 55px;
    line-height: 55px;
    border: 1px solid #eee;
    border-top: 0;
    border-left: 0;
    box-sizing: border-box;
    text-align: left;
    padding-left: 30px;
}
.el-input{
    width: 70px;
    margin-right: 10px
}
</style>
